<template>
  <div id="team-choice-form">
    <header class="panel__header mt-2">
      <div class="row">
        <div class="col-8">
          <h2 class="panel__title">Escolha o seu clube do coração</h2>
        </div>
        <div class="col-4">
          <select
            class="form-select"
            v-model="selectedLeague"
            name="leagues"
          >
            <option v-for="league in leagues" :key="league" :value="league"> Série {{league}} </option>
          </select>
        </div>
      </div>
    </header>

    <div id="form-dados-pessoais" class="row mt-4">
      <div class="col-12">
        <div class="row">
          <div
            v-for="team in selectedLeagueTeams" 
            :key="team.id"
            class="col-3 col-md-custom-team d-flex justify-content-center align-items-center"
          >
            <div :class="{'shield-wrapper': true, 'active': team.id == currentTeam.id}" @click="chooseTeam(team)">
              <img class="team-shield" :src="team.shield_url" :alt="`Escudo do ${team.name}`">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert
          variant="danger"
          :show="error.show"
          v-model="error.show"
        >
          <div>{{ error.message }}</div>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      selectedLeague: null,
      currentTeam: {
        id: 0
      },
      error: {
        show: false,
        message: ''
      }
    }
  },
  mounted() {
    this.selectedLeague = this.leagues[0]
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    teams: {
      required: true,
      type: Array
    },
  },
  methods: {
    submit() {
      if (!this.validate()) {
        this.error.show = true
        this.error.message = "Você precisa escolher um clube para prosseguir"
        return false
      } else {
        this.user.team = this.currentTeam
        return true
      }
    },
    validate() {
      return this.currentTeam.id != 0
    },
    chooseTeam(team) {
      this.currentTeam = team
    }
  },
  computed: {
    leagues() {
      return Array.from(new Set(this.teams.map(team => team.league)))
    },
    selectedLeagueTeams() {
      return this.teams.filter(team => team.league === this.selectedLeague)
    }
  }
})
</script>